import React, { useState, useRef, useEffect } from 'react';

import { Link } from 'react-router-dom';

// import Swiper React components
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

const PricingSlider = () => {

    const [checked] = useState(true);
    const ref = useRef(null);

    const price_number_height = () => {
        const prices = ref.current.querySelectorAll('.price');

        if (prices.length < 1) return;

        Array.from(prices).forEach((price) => {
            const month = price.querySelector('.month');
            const year = price.querySelector('.year');
    
            price.style.height = Math.max(month.offsetHeight, year.offsetHeight) - 2 + 'px';
            // price.style.width = Math.max(month.offsetWidth, year.offsetWidth) + 'px';
        });
    }

    useEffect(() => {
        price_number_height();
        window.addEventListener('resize', price_number_height);

        return () => {
            window.removeEventListener('resize', price_number_height);
        }
    }, []);

    useEffect(() => {
        const prices = ref.current.querySelectorAll('.price');

        if (prices.length < 1) return;

        if ( checked ) {
            Array.from(prices).forEach((price) => {
                if ( price === undefined || price === null ) return;
                price.classList.remove('price-month');
            });
        } else {
            Array.from(prices).forEach((price) => {
                if ( price === undefined || price === null ) return;
                price.classList.add('price-month');
            });
        }
    }, [checked])


    return (
        <div className="pricing">
            <div className="row">
                <div className="col">
                    {/* <div className="switch">
                        <div className="form-check form-switch">
                            <label 
                            className="form-check-label" 
                            htmlFor="price-switch">With out Ensight</label>
                            <input 
                            className="form-check-input" 
                            type="checkbox" 
                            id="price-switch" 
                            onChange={() => { setChecked( !checked ) }}
                            defaultChecked={checked}
                            />
                            <label 
                            className="form-check-label" 
                            htmlFor="price-switch">With Ensight</label>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="pricing-slider" ref={ref}>
                        <Swiper
                            className='swiper-container'
                            resizeObserver={true}
                            breakpoints={{
                                0: {
                                    enabled: true,
                                    centeredSlides: true,
                                    slidesPerView: 1.2,
                                    spaceBetween: 30,
                                    initialSlide: 1
                                },
                                400: {
                                    enabled: true,
                                    centeredSlides: true,
                                    slidesPerView: 1.4,
                                    spaceBetween: 30,
                                    initialSlide: 1
                                },
                                576: {
                                    enabled: true,
                                    centeredSlides: true,
                                    slidesPerView: 1.5,
                                    spaceBetween: 30,
                                    initialSlide: 1
                                },
                                768: {
                                    enabled: true,
                                    centeredSlides: true,
                                    slidesPerView: 1.8,
                                    spaceBetween: 30,
                                    initialSlide: 1
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                    enabled: false,
                                    centeredSlides: false
                                }
                            }}
                            pagination={false}
                        >
                            <SwiperSlide>
                                <div className="pricing-single basic">
                                    <h5 className="plan">Homes</h5>
                                    <div className="price price-month">
                                        <div className="month">
                                            <span className="number">Quarterly Insight </span>
                                        </div>
                                        <div className="year">
                                            <span className="number">Live Insight </span>
                                        </div>
                                    </div>
                                    <Link to="/contact" className="button button-basic">
                                        <div className="button-inner">
                                            <div className="button-content">
                                                <h4>1 to 3 people</h4>
                                            </div>
                                        </div>
                                    </Link>

                                    {/* <div className="price price-month">
                                        <div className="month">
                                            <ul>
                                            <li>Live Monitoring</li>
                                            <li>Instant limit notifications</li>
                                            <li className="available">Historical Consumption</li>
                                            <li>Device Disaggregation</li>
                                            <li className="available">Consmations Goals</li>
                                            <li className="available">Mobile Application</li>
                                            <li>Energy Dashboard</li>
                                            <li>API Access</li>
                                            <li>Custome Reports</li>
                                            </ul>
                                        </div> */}
                                        {/* <div className="year"> */}
                                            <ul>
                                            <li className="available">Live Monitoring</li>
                                            <li className="available">Instant limit notifications</li>
                                            <li className="available">Historical Consumption</li>
                                            <li className="available">Device Disaggregation</li>
                                            <li className="available">Consumption Goals</li>
                                            <li className="available">Mobile Application</li>
                                            <li>Energy Dashboard</li>
                                            <li>API Access</li>
                                            <li>Custom Reports</li>
                                            </ul>
                                        {/* </div>
                                    </div> */}

                                    <h6>No commitment, cancel anytime.</h6>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="pricing-single standard">
                                    <h5 className="plan">Business</h5>
                                    <div className="price price-month">
                                    <div className="month">
                                            <span className="number">Quarterly Insight </span>
                                        </div>
                                        <div className="year">
                                            <span className="number">Live Insight </span>
                                        </div>
                                    </div>
                                    <Link to="/contact" className="button button-standard">
                                        <div className="button-inner">
                                            <div className="button-content">
                                                <h4>Get Started</h4>
                                            </div>
                                        </div>
                                    </Link>
                                    <ul>
                                        <li className="available">Live Monitoring</li>
                                        <li className="available">Instant limit notifications</li>
                                        <li className="available">Historical Consumption</li>
                                        <li className="available">Device Disaggregation</li>
                                        <li className="available">Consumption Goals</li>
                                        <li className="available">Mobile Application</li>
                                        <li className="available">Energy Dashboard</li>
                                        <li>API Access</li>
                                        <li>Custom  Reports</li>
                                    </ul>
                                    <h6>6 months commitment, cancel anytime.</h6>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="pricing-single premium">
                                    <h5 className="plan">Providers</h5>
                                    <div className="price price-month">
                                        <div className="month">
                                            <span className="number">Customers</span>
                                        </div>
                                        <div className="year">
                                            <span className="number">Happy Customers</span>
                                        </div>
                                    </div>
                                    <Link to="/contact" className="button button-premium">
                                        <div className="button-inner">
                                            <div className="button-content">
                                                <h4>Get Started</h4>
                                            </div>
                                        </div>
                                    </Link>
                                    <ul>
                                    <li className="available">Live Monitoring</li>
                                        <li className="available">Instant limit notifications</li>
                                        <li className="available">Historical Consumption</li>
                                        <li className="available">Device Disaggregation</li>
                                        <li className="available">Consumption Goals</li>
                                        <li className="available">Mobile Application</li>
                                        <li className="available">Energy Dashboard</li>
                                        <li className="available">API Access</li>
                                        <li className="available">Custom Reports</li>
                                    </ul>
                                    <h6>12 months commitment, cancel anytime.</h6>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingSlider;
